import React from 'react';
import { useSnackbar } from '../contexts/SnackbarContext';
import { Snackbar } from './Snackbar';
import { useIsMobile } from '../hooks/useIsMobile';

export function SnackbarContainer() {
  const { snackbars } = useSnackbar();
  const isMobile = useIsMobile();

  if (snackbars.length === 0) return null;

  return (
    <div
      aria-live="polite"
      aria-atomic="false"
      style={{
        position: 'fixed',
        bottom: isMobile ? 16 : 24,
        right: isMobile ? '50%' : 24,
        transform: isMobile ? 'translateX(50%)' : 'none',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        alignItems: isMobile ? 'center' : 'flex-end',
        width: isMobile ? 'calc(100% - 32px)' : 'auto',
        maxWidth: isMobile ? 400 : 'none',
        pointerEvents: 'none',
      }}
    >
      {snackbars.map(s => (
        <div key={s.id} style={{ pointerEvents: 'auto', width: isMobile ? '100%' : 'auto' }}>
          <Snackbar
            id={s.id}
            message={s.message}
            variant={s.variant}
            duration={s.duration}
          />
        </div>
      ))}
    </div>
  );
}
